module.exports = __webpack_public_path__ + "static/img/jiangbei.89c7fd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jiangbei.png
// module id = KARB
// module chunks = 1